<template>
    <button :type="type" class="font-semibold bg-black text-white w-full disabled:opacity-25 uppercase">
        {{ text }}
    </button>
</template>


<script>
export default {
    props: {
        type: {
            type: String,
            default: 'submit'
        },
        text: {
            type: String,
            required: true
        },
    }
}
</script>
<style lang="scss" scoped>
button {
    //margin-top: 3.5rem;
    padding: 0.88rem;
}
</style>
